module.exports = __webpack_public_path__ + "img/2018-04-28.6fab73e1.jpg";